import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { Image } from "../../Instance";
import { objectToQuery } from "../../ObjectToQuery";

export class GetTayehMarketplaceShopResponse {
    name: string;
    username: string;
    logo: Image;
    rating_average: number = null;
    description: string = null;
    products: any[]
    domain?: string;
    // engagment: number = 0;
}

class getTyMarketplaceShopsQuery {
    page? = 0;
    per_page? = 16;
    sort?: string;
}

export function getTyMarketplaceShops(params?: getTyMarketplaceShopsQuery): Promise<AxiosResponse<{shops: GetTayehMarketplaceShopResponse[], count: number}>>{
    const query = `/marketplace/shops?${objectToQuery(params)}`;
    return Cirus.get(query);
}